import { contentTypeBasePathMap, indexPageSlug } from '@lib/constants'
import type { PageContentTypes } from '@lib/types'

export type Slug = string | string[] | undefined

export function buildSlug(slug: Slug): string | undefined {
  if (Array.isArray(slug)) return slug.join('/')

  return slug
}

export function buildCanonicalPath(slug: Slug, contentType: PageContentTypes): string {
  const basePath = contentTypeBasePathMap[contentType]
  const slugStr = buildSlug(slug) ?? ''
  // if index page just base path without trailing slash
  if (slugStr === indexPageSlug || slugStr === '') return basePath.replace(/\/$/, '')

  return `${basePath}${slugStr}`
}

/**
 * Ensures a URL has a protocol. If missing, prepends "https://".
 * If url is an empty string, returns it unchanged.
 * @param url - The image URL or path.
 * @returns The URL with protocol
 */
export const ensureProtocol = (url: string): string => {
  if (!url) return url
  return url.replace(/^(?!(?:https?:)?\/\/)/i, 'https://').replace(/^\/\//, 'https://')
}

const methods = {
  buildSlug,
  buildCanonicalPath,
  ensureProtocol,
}

export default methods
